<template>
  <li v-if="show" class="" role="presentation" v-on="$listeners">
    <button
        :id="`${id}-tab`"
        :aria-controls="id"
        :aria-selected="selected"
        :data-tabs-target="`#${id}`" class="inline-block outline-none p-4"
        role="tab"
        type="button">
      <slot></slot>
    </button>
  </li>
</template>

<script>
export default {
  name: "TabHeader",
  props: {
    id: String,
    show: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    },
  }
}
</script>

